import lunr from "/workspace/frontend/docs-site/node_modules/lunr/lunr.js";
require("/workspace/frontend/docs-site/node_modules/lunr-languages/lunr.stemmer.support.js")(lunr);
require("/workspace/frontend/docs-site/node_modules/lunr-languages/lunr.pt.js")(lunr);
require("/workspace/frontend/docs-site/node_modules/lunr-languages/lunr.multi.js")(lunr);
export const removeDefaultStopWordFilter = [];
export const language = ["pt","en"];
export const searchIndexUrl = "search-index{dir}.json?_=06f36fe8";
export const searchResultLimits = 8;
export const fuzzyMatchingDistance = 1;